var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9509 12.25C12.116 12.25 12.25 12.1203 12.25 11.9604C12.25 9.56184 10.7392 7.40187 8.51449 6.52546C9.32351 5.87434 9.83968 4.89311 9.83968 3.79734C9.83968 1.84138 8.19576 0.25 6.17521 0.25C4.15467 0.25 2.51075 1.84138 2.51075 3.79734C2.51075 4.89354 3.02722 5.87507 3.83684 6.52633C1.67017 7.38768 0.25 9.50407 0.25 11.9604C0.25 12.1203 0.384015 12.25 0.54914 12.25C0.714265 12.25 0.84828 12.1203 0.84828 11.9604C0.84828 9.59891 2.29223 7.58851 4.45052 6.92609C4.96489 7.19294 5.55196 7.34468 6.17521 7.34468C6.79847 7.34468 7.38553 7.19294 7.89991 6.92609C10.1134 7.60385 11.6517 9.66001 11.6517 11.9604C11.6517 12.1204 11.7856 12.25 11.9509 12.25ZM3.10903 3.79734C3.10903 2.16064 4.48448 0.829158 6.17521 0.829158C7.86595 0.829158 9.2414 2.16064 9.2414 3.79734C9.2414 5.43404 7.86595 6.76552 6.17521 6.76552C4.48448 6.76552 3.10903 5.43404 3.10903 3.79734Z",
    fill: "#394150",
    stroke: "#394150",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonal);
export default __webpack_public_path__ + "static/media/Personal.719a29110c9682d33905e850d643c432.svg";
export { ForwardRef as ReactComponent };